export const formTypes = {
    CREATE: 0,
    EDIT: 1
}

export const createStates = {
    RESET: 0,
    CONFIRM: 1,
    ERROR: 2
}